import Maison1 from '../Maison/Maison (1).webp'
import Maison2 from '../Maison/Maison (2).webp'
import Maison3 from '../Maison/Maison (3).webp'
import Maison4 from '../Maison/Maison (4).webp'
import Maison5 from '../Maison/Maison (5).webp'
import Maison6 from '../Maison/Maison (6).webp'
import Maison7 from '../Maison/Maison (7).webp'
import Maison8 from '../Maison/Maison (8).webp'

const Maisonimages =[
Maison1,Maison2,Maison3,Maison4,Maison5,Maison6,Maison7,Maison8
]

export default Maisonimages;